// @flow
import React from 'react'

import styled from 'styled-components'
import getSentimentColors from 'utils/getSentimentColors'

import Text from 'components/Text'

const Root = styled.div`
	display: inline-block;
	margin-left: 8px;
	padding: 4px 10px;
	border-radius: 20px;
	white-space: nowrap;
	flex-grow: 0;
	flex-shrink: 0;

	${props => `background-color: ${getSentimentColors(props.sentiment).bg};`}

	& * {
		white-space: nowrap;
	}
`

export default function MenuTag(props) {
	const { sentiment = 'positive', text } = props

	return (
		<Root sentiment={sentiment}>
			<Text
				$color={getSentimentColors(sentiment).fg}
				rawColor={getSentimentColors(sentiment).fg}
				weight={500}
				rawFontSize='10px'
				lineHeight='10px'
				transform='uppercase'
			>
				{text}
			</Text>
		</Root>
	)
}
